
export default function FAQ({ t }) {
  const UPDATED = '2025-10-08';

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('faq.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">
        {t('general.lastUpdated', { date: UPDATED })}
      </p>

      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold">{t('faq.inviteAdmins.title')}</h2>
          <p className="text-gray-700">{t('faq.inviteAdmins.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold">{t('faq.addContent.title')}</h2>
          <p className="text-gray-700">{t('faq.addContent.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold">{t('faq.files.title')}</h2>
          <p className="text-gray-700">{t('faq.files.body')}</p>
        </div>
      </div>
    </div>
  );
}

